interface DeviationDiffItem {
  id?: string
  title?: string
}

// The deviation copies MPI items with their ids, while title (the part/equipment revision id) changes on a new
// revision, so an item matches on either one
export const findDeviationMatch = <T extends DeviationDiffItem>(item: DeviationDiffItem, list?: T[]): T | undefined =>
  list?.find((i) => (item.id && i.id === item.id) || (item.title && i.title === item.title));
